import React, { useState } from "react";

const Sidebar = ({ onSelectTool }) => {
  const [showTrendTools, setShowTrendTools] = useState(false);

  return (
  <aside className="w-16 bg-gray-900 text-white flex flex-col items-center py-4 space-y-6 relative">
      {/* 📈 Trend Line Tools */}
      <div className="relative">
     <button
  className="hover:bg-gray-700 p-2 rounded"
  onClick={() => setShowTrendTools((p) => !p)}
  title="Trend Line Tools"
>

    
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 28 28"
    width="28"
    height="28"
    className="text-white"
  >
    <g fill="currentColor">
      <path d="M18 15h8v-1h-8z"></path>
      <path d="M14 18v8h1v-8zM14 3v8h1v-8zM3 15h8v-1h-8z"></path>
    </g>
  </svg>
</button>


        {showTrendTools && (
          <div className="absolute left-16 top-0 bg-gray-800 border border-gray-700 rounded-lg shadow-lg p-2 w-48 z-50">
            <h3 className="text-gray-300 text-sm px-2 mb-2">Trend Line Tools</h3>
            <button
              onClick={() => onSelectTool("trendline")}
              className="flex justify-between w-full px-3 py-1 hover:bg-gray-700 rounded"
            >
              <span>Trend Line</span>
              <span className="text-xs text-gray-400">Alt + T</span>
            </button>
          </div>
        )}
      </div>

      {/* <button
        className="hover:bg-gray-700 p-2 rounded"
        onClick={() => onSelectTool(null)}
        title="Cancel Tool"
      >
        ❌
      </button> */}
    </aside>
  );
};

export default Sidebar;
